import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { jwtDecode } from 'jwt-decode';

function RegisterForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/public/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, firstName, lastName }),
      });

      if (!response.ok) {
        const message = await response.text();
        throw new Error(message || 'Registration failed');
      }

      const data = await response.json();
      localStorage.setItem('token', data.token);
       // ✅ Decode the token to extract email + userId

          const decoded = jwtDecode(data.token);
       console.log(decoded);
          const userEmail = decoded.sub;
          const userId = decoded.userId || decoded.id; // depending on your JWT payload
      
      localStorage.setItem("user", JSON.stringify(userEmail));
          login(userEmail, userId);
      

      navigate('/');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem', gap: '3rem', flexWrap: 'wrap' }}>
      {/* Register Form */}
      <div style={{
        flex: '1',
        minWidth: '340px',
        maxWidth: '420px',
        padding: '2rem',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#fff'
      }}>
        <h2 style={{ marginBottom: '1rem' }}>Create Your Free Account</h2>
        <form onSubmit={handleRegister}>
          <input type="text" placeholder="First Name" value={firstName}
            onChange={(e) => setFirstName(e.target.value)} required
            style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem' }}
          />
          <input type="text" placeholder="Last Name" value={lastName}
            onChange={(e) => setLastName(e.target.value)} required
            style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem' }}
          />
          <input type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} required
            style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem' }}
          />
          <input type="password" placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)} required
            style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem' }}
          />
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <button type="submit" style={{
            width: '100%',
            padding: '0.75rem',
            backgroundColor: '#00796B',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            fontWeight: 'bold'
          }}>
            Register
          </button>
        </form>
        <p style={{ marginTop: '1rem', textAlign: 'center' }}>
          Already have an account? <a href="/login">Login here</a>
        </p>
      </div>

      {/* Signup Benefits */}
      <div style={{
        flex: '1',
        minWidth: '300px',
        maxWidth: '420px',
        paddingTop: '2rem',
        color: '#333'
      }}>
        <h3 style={{ color: '#004D40', marginBottom: '1rem' }}>✅ Why Sign Up?</h3>
        <ul style={{ paddingLeft: '1rem', lineHeight: '1.8' }}>
          <li>🔖 <strong>Save Your Favorite Cars</strong><br />Easily revisit listings you like.</li>
          <li>📉 <strong>Get Notified of Price Drops</strong><br /><em>(Coming Soon)</em> Stay informed.</li>
          <li>💬 <strong>See All Cars Sold at a Dealer</strong><br />Understand dealer pricing trends.</li>
          <li>📊 <strong>Compare Prices to Recently Sold Cars</strong><br />Spot over- or underpriced deals.</li>
          <li>📍 <strong>Local Inventory by ZIP</strong><br />Auto-prioritized results by proximity.</li>
          <li>🧠 <strong>Better Negotiation Insight</strong><br />With verified sold comps.</li>
          <li>🔐 <strong>It’s Free and Secure</strong><br />No spam. Cancel anytime.</li>
        </ul>
      </div>
    </div>
  );
}

export default RegisterForm;
